import { render, staticRenderFns } from "./FormulaManage.vue?vue&type=template&id=68e0093c&scoped=true&"
import script from "./FormulaManage.vue?vue&type=script&lang=js&"
export * from "./FormulaManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e0093c",
  null
  
)

export default component.exports